import React, { ReactElement, useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Radio, RadioGroup, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { AppConstants } from "../../../../types/Constants";
import { setBeaconSearchText, setCategoryFilter } from "../../../../redux/actions";
import BeaconCategory from "../../../../components/BeaconCategory";

interface FilterDialogProps {
    isOpen: boolean
    onClose: () => void;
}

const FilterDialog: React.FC<FilterDialogProps> = (prop) => {

    const dispatch = useAppDispatch();
    const beaconState = useAppSelector(state => state.beacon);
    const categoryGroupState = useAppSelector(state => state.category);

    const [selectedCategory, setSelectedCategory] = useState<string>(beaconState.filterCategory ?? AppConstants.AllCategoriesValue);

    useEffect(() => {
        const newCategory = (beaconState.filterCategory) ? beaconState.filterCategory : AppConstants.AllCategoriesValue;
        setSelectedCategory(newCategory);
    }, [beaconState.filterCategory]);

    const handleSelectCategory = (key: string, checked: boolean) => {
        if (checked) {
            setSelectedCategory(key);
        }
    };

    const createCategoryRadioButtons = () => {
        const buttons: ReactElement[] = [];
        categoryGroupState.categories?.map((category) => {
            buttons.push(
                <Box key={category.Name + "filter"} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", margin: 0 }}>
                    <Radio checked={selectedCategory === category.Name} onChange={(checked) => handleSelectCategory(category.Name, checked.target.checked)} />
                    <Box width="75%">
                        <BeaconCategory 
                            category={category.Name} 
                            justifyContent="left"
                            icons={true}
                            id={category.Id ?? ""}
                        />
                    </Box>
                </Box>
            );
        });
        return buttons;
    };

    const handleClose = () => {
        // Cancel change
        const newCategory = (beaconState.filterCategory) ? beaconState.filterCategory : AppConstants.AllCategoriesValue;
        setSelectedCategory(newCategory);
        prop.onClose();
    };

    const handleApplyFilter = () => {

        if (beaconState.filterCategory !== selectedCategory) {
            // Clear search text. Can not query for both text and category
            dispatch(setBeaconSearchText(null));

            dispatch(setCategoryFilter(selectedCategory));
        }
        prop.onClose();
    };

    return (
        <Dialog
            sx={{
                '& .MuiDialog-paper': {
                    width: "200px",
                    backgroundColor: "white",
                    position: 'absolute',
                    right: 20,
                    top: 100
                },
                '& .MuiDialogContent-root': {
                    overflowY: 'hidden',
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            }}
            open={prop.isOpen}
            onClose={handleClose}>
            <DialogContent dividers={true} sx={{ paddingY: 2 }}>
                <RadioGroup defaultValue="all">
                    <Box
                        key={AppConstants.AllCategoriesValue}
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            margin: 0
                        }}>
                        <Radio
                            checked={selectedCategory === AppConstants.AllCategoriesValue}
                            onChange={(checked) => handleSelectCategory(AppConstants.AllCategoriesValue, checked.target.checked)} />
                        <Typography>All Categories</Typography>
                    </Box>
                    {createCategoryRadioButtons()}
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleApplyFilter()} variant="outlined">OK</Button>
            </DialogActions>
        </Dialog>
    );
};

export default FilterDialog;
